import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { isArray } from 'lodash';
import RowRadioList from '../RowRadioList';
import { setFormValue, getFormValue } from '@/store';

const HolderRelation = props => {
  const parentFormKey = props.formKey.replace('.holderRelation', ''); // 切换与投保人关系时，

  const getReserveData = () => {
    // 被保人filed name
    const names = props.form.getFieldsName(({
      name
    }) => {
      if (Array.isArray(name) && name.length) {
        // 是否是当前投保人关联的因子
        return name.some(key => key.includes(parentFormKey));
      }

      return false;
    });
    const insuredData = getFormValue(parentFormKey) || {};
    const keys = Object.keys(insuredData); // 过滤非 FormItem 生成的数据 如其他的状态

    return isArray(keys) ? keys.reduce((res, key) => {
      const isField = names.some(name => name.includes(`${parentFormKey}.${key}`));

      if (!isField) {
        res[key] = insuredData[key];
      }

      return res;
    }, {}) : {};
  }; //  change


  const onChange = val => {
    setFormValue(parentFormKey, _objectSpread(_objectSpread({}, getReserveData()), {}, {
      holderRelation: val
    }));
  };

  return /*#__PURE__*/React.createElement(RowRadioList, _extends({}, props, {
    onChange: onChange
  }));
};

export default HolderRelation;